<template>
    <div v-if="show" class="loading-cover">
      <div class="loading-box">
        <div class="spinner" />
        <div class="msg">{{ message }}</div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "LoadingCover",
    props: {
      show: { type: Boolean, default: false },
      message: { type: String, default: "Loading…" },
    },
  };
  </script>
  
  <style scoped>
  .loading-cover {
    position: absolute;
    inset: 0;
    z-index: 50;
    background: rgba(255,255,255,0.85);
    backdrop-filter: blur(2px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .loading-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 16px 20px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 6px 24px rgba(0,0,0,0.08);
  }
  .spinner {
    width: 28px;
    height: 28px;
    border: 3px solid #e5e7eb;
    border-top-color: #0f172a;
    border-radius: 50%;
    animation: spin 0.9s linear infinite;
  }
  .msg { color: #0f172a; font-weight: 600; }
  @keyframes spin { to { transform: rotate(360deg); } }
  </style>
  